/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Claim_Status_ClosedInputs */

const en_claim_status_closed = /** @type {(inputs: Claim_Status_ClosedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Closed`)
};

/**
* | output |
* | --- |
* | "Closed" |
*
* @param {Claim_Status_ClosedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const claim_status_closed = /** @type {((inputs?: Claim_Status_ClosedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Claim_Status_ClosedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_claim_status_closed(inputs)
});